import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { REVIEW_API, type ReviewSession } from '@chess/api-review';
import { useSelect } from '@chess/api-review/react';
import { BookSection } from './BookSection.tsx';
import { lineOf } from './line.ts';
import './opening.css';

// The opening's own section of the Opening tab, one line: what this game is
// playing with its ECO code, and where the players left the theory with a
// jump to the last position in the book. The book's reading of the game is
// the review session's, loaded once per game for every panel; the moves the
// book knows from the board's position are shown by the best-moves place.
// The tab itself, its head and the other sections are other plugins'; this
// one is pinned under the stage header (`tab: 'header'`).

const SLOT = 'review.opening.sections';

export function setup(app: PiletApi) {
  void app.getApi<ReviewSession>(REVIEW_API).then((review) => {
    const Section: React.FC = () => {
      const line = useSelect(review, lineOf) ?? { status: 'idle' as const };
      // Framed by review-stage-section like every stage section; untitled, so
      // the frame gives only the shared spacing.
      return (
        <app.Extension name="review.stageSection" params={{}}>
          <BookSection
            status={line.status}
            opening={line.reading ? { eco: line.reading.opening.eco, name: line.reading.opening.name } : undefined}
            statusText={line.statusText}
            leftAtPly={line.leftAtPly}
            onGo={(ply) => review.go(ply)}
          />
        </app.Extension>
      );
    };
    app.registerExtension(SLOT, Section, { order: 0, tab: 'header' });
  });
}
